import 'animate.css';
import { t } from 'i18next';
import React, { useEffect, useState, Fragment } from 'react';
import { fetchOrderById, fetchOrderByTime } from '../../api';
import i18n from '../../i18n';
import Ratings from '../ratings';
import Header from './../../components/header';
import ReceiptTable from './receipt-table';
import Summary from './summary';
import UserRatings from './userRatings';
import icons from './../../images/icons.svg'

import packageJson from '../../../package.json'

const App = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [receipt, setReceipt] = useState(null)
  const [receiptNotFound, setReceiptNotFound] = useState(false)
  const [mode, setMode] = useState(3)
  const [selectedLanguage, setSelectedLanguage] = useState('en');
  const [isOverCapture, setIsOverCapture] = useState(false)

  useEffect(() => {

    console.log("version: " + packageJson.version);
    const params = new URLSearchParams(window.location.search)
    const unixTimestamp = params.get('t')
    const deviceCode = params.get('deviceCode')
    const language = params.get('lang');
    const orderId = params.get('orderId');
    const overCapture = params.get("overCapture");
    const mode = params.get("mode");

    if(overCapture==="true")setIsOverCapture(true)

    language && window.localStorage.setItem('languageOptions', JSON.stringify({ currentLang: language, fallbackLang: "en" }))
    i18n.changeLanguage(language);
    setSelectedLanguage(i18n.resolvedLanguage)
    
   // Redirect if mandatory params are missing
    if (!orderId && (!unixTimestamp || !deviceCode)) {
      window.location.replace('https://www.selflystore.com')
    }

    setIsLoading(true)

    if (orderId) {
      let requestCount=0;   

      const fetchFromAPI =()=>{        
        requestCount = requestCount + 1;
        fetchOrderById(orderId).then(result=>{
          // for nayax and ingenico transaction is not ready or is in overcapture state.
          // continue requesting in 7s interval for 30 times or until the status is resolved
          let organizationDetails = result?.consumerAppSettings;

          if (mode) {
            setMode(parseInt(mode));
          } else if (organizationDetails.enableFeedback && organizationDetails.enableReceipt) {
            setMode(2);
          }
          else if (organizationDetails.enableReceipt && !organizationDetails.enableFeedback) {
            setMode(3)
          }
          else if (!organizationDetails.enableReceipt && organizationDetails.enableFeedback) {
            setMode(1)
          }

          if(result.status && (result.status ==='NEW' || result.status ==='IN_PROGRESS')){
            if(requestCount>30){
              setIsLoading(false)
              setReceiptNotFound(true)
            }else{
              setTimeout(()=>{fetchFromAPI()}, 7000)
            }            
          }else if(result.status && (result.status ==='DONE' || result.status ==='PARTIAL')){
            //setMode(4);
            setIsLoading(false)
            setReceipt(result)
            return true;
          }else{
            setIsLoading(false)
            setReceiptNotFound(true)
          }
        }).catch((error)=>{
          // cases where transaction is still being processed and orderID not yet ready in DB
          // wait about 35s for transaction completion.
          if(error && error.status === 404 && requestCount<=30){
            setTimeout(()=>{fetchFromAPI()},7000)
          }else{
            setIsLoading(false)
            setReceiptNotFound(true)
          } 
        })
      }
      fetchFromAPI()
    }else {
      fetchOrderByTime(unixTimestamp, deviceCode).then(result => {
        
        setReceipt(result)

        let organizationDetails = result?.consumerAppSettings;

        if (organizationDetails.enableFeedback && organizationDetails.enableReceipt) {
          setMode(2);
        }
        else if (organizationDetails.enableReceipt && !organizationDetails.enableFeedback) {
          setMode(3)
        }
        else if (!organizationDetails.enableReceipt && organizationDetails.enableFeedback) {
          setMode(1)
        }

        setIsLoading(false)
      })
        .catch(() => {
          setIsLoading(false)
          setReceiptNotFound(true)
        });
    }

  }, [])


  const showReceipt = () => {
    if (mode === 2 || mode === 3 || mode === 4) return true;
    else if (mode === 1) return false;
  }

  return (
    <>
      <Header device={receipt?.device} locationName={receipt?.locationName} organizationName={receipt?.consumerAppSettings?.organisationName} selectedLanguage={selectedLanguage} setSelectedLanguage={setSelectedLanguage} />
      {!receiptNotFound && !isLoading && receipt && receipt.status !== "FAIL" ? (
        <div className="mySelflyContainer">
          {!showReceipt() ? (
            <Ratings receipt={receipt} />
          ) : (
            <>
              <Summary receipt={receipt} />
              <ReceiptTable mode={mode} device={receipt?.device} receipt={receipt} />
              {(mode !== 4 && mode !== 3) && <UserRatings receipt={receipt} />}
            </>
          )
          }
        </div>
      ) : (
        <div className="status-container">
          {
            (isOverCapture && isLoading) && (
              <div className="status-container__info">
                {t('completeTransactionFirst')}
              </div> 
              )
          }
          {
            (!isOverCapture && isLoading) && (
              <div className="status-container__spinner">
                <div className="status-container__circle"></div>
                <div className="status-container__text">{t('pleaseWait')}...</div>
              </div>
            )
          }
          {(receiptNotFound || (receipt && receipt.status === "FAIL")) &&
            <div className="status-container__info">
              <div>{t('receiptNotFound')}</div>
              <div onClick={() => {
                window.location.reload(false);
                }}
                className='refresh'>
                    <svg>
                        <use xlinkHref={`${icons}#icon-loop2`}></use>
                    </svg>
                </div>              
            </div>
          }
        </div>
      )

      }
    </>
  )
}
export default App;